import {Brick, registerBrick} from 'olympe';
import {createApplicationStore} from './createApplicationStore';

/**
 * This brick creates the application store, with user settings information
 */
export default class InitializeApplicationStore extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} userSettings
     * @param {*} columnsToDisplay
     * @param {function()} forwardEvent
     * @param {function(*)} setApplicationStore
     */
    update($, [userSettings, columnsToDisplay], [forwardEvent, setApplicationStore]) {
        const columnNamesArray = columnsToDisplay.map((col) => col.getColumnName());
        const userSettingsObject = userSettings.hasOwnProperty('dateFormat') ? userSettings : userSettings.getUserSettingsObject();

        const useApplicationStore = createApplicationStore({
            'dateFormat': userSettingsObject.dateFormat,
            'separator': userSettingsObject.separator,
            'columnsToDisplay': columnNamesArray,
        });

        setApplicationStore(useApplicationStore);
        forwardEvent();
    }
}

registerBrick('0191123359224fe8016f', InitializeApplicationStore);
